export const FORM_OF_EDUCATION_FULL_TIME = "Full-time (On-campus)";
export const FORM_OF_EDUCATION_DISTANCE = "Distance (online)";

export const FORM_OF_EDUCATION_OPTIONS = [
  { value: FORM_OF_EDUCATION_FULL_TIME, label: FORM_OF_EDUCATION_FULL_TIME },
  { value: FORM_OF_EDUCATION_DISTANCE, label: FORM_OF_EDUCATION_DISTANCE },
] as const;

export const MALTA_FORM_OF_EDUCATION_LABELS = FORM_OF_EDUCATION_OPTIONS.map(({ label }) => label);

export const resolveFormOfEducationValue = (value?: string | null): string => (value ?? "").trim();
